export default "__VITE_ASSET__81420196__"